import { BasePagePath } from "app/core/workflow/page-path/base-page.path";

export class ContractWithdrawalPagePath extends BasePagePath {
  public static path(): string {
    return "vertrag-widerrufen";
  }
}
